import { render, staticRenderFns } from "./TranslationsMaterial.vue?vue&type=template&id=5972218a&"
import script from "./TranslationsMaterial.vue?vue&type=script&lang=js&"
export * from "./TranslationsMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports